import { Shield, Lock, Truck, RotateCcw, CreditCard, Award } from 'lucide-react';

export const TrustBadges = () => {
  const badges = [
    {
      icon: Lock,
      title: '256-bit SSL Encryption',
      description: 'Your data is fully protected'
    },
    {
      icon: Shield,
      title: 'Money-Back Guarantee',
      description: '30-day no questions asked'
    },
    {
      icon: Truck,
      title: 'Free Shipping',
      description: 'On orders over £50'
    },
    {
      icon: RotateCcw,
      title: 'Easy Returns',
      description: 'Hassle-free process'
    },
    {
      icon: CreditCard,
      title: 'Secure Payments',
      description: 'All major cards accepted'
    },
    {
      icon: Award,
      title: 'Quality Guaranteed',
      description: 'Premium ingredients only'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 py-8 border-y border-border/50">
      {badges.map((badge, index) => {
        const Icon = badge.icon;
        return (
          <div
            key={index}
            className="flex flex-col items-center text-center gap-2 p-3 rounded-lg hover:bg-accent/5 transition-colors"
          >
            <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
              <Icon className="h-5 w-5 text-primary" />
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground">{badge.title}</p>
              <p className="text-xs text-muted-foreground">{badge.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};